import { IEmployeeAppResource } from '@dadohr/shared/domainTypes/experience';
import {
  PAEventType,
  ProductAnalyticsEvent
} from '@dadohr/shared/domainTypes/productAnalytics';
import { LinkExternal } from '../../../../../../components/LinkExternal';

export const Resource = ({
  d,
  trackFn
}: {
  d: IEmployeeAppResource;
  trackFn?: (ev: ProductAnalyticsEvent) => void;
}) => {
  if (d.type === 'LINK') {
    return (
      <LinkExternal
        href={d.url}
        color="primary"
        onClick={
          trackFn &&
          (() =>
            trackFn({
              eventType: PAEventType.EMPLOYEE_EXPERIENCE_INSTANCE,
              name: 'Resources Link Clicked',
              Explanation: 'User clicked on a link in the Resources section',
              'Link Title': d.label || d.url,
              'Link URL': d.url
            }))
        }
      >
        {d.label || d.url}
      </LinkExternal>
    );
  }
  return null;
};
